module.exports = __webpack_public_path__ + "static/img/tencent@2x.6ed0398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/tencent@2x.png
// module id = UxDv
// module chunks = 1